import { render, staticRenderFns } from "./form-date-picker.vue?vue&type=template&id=5bb4c922&scoped=true&"
import script from "./form-date-picker.vue?vue&type=script&lang=ts&"
export * from "./form-date-picker.vue?vue&type=script&lang=ts&"
import style0 from "./form-date-picker.vue?vue&type=style&index=0&id=5bb4c922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4c922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VIcon,VMenu,VTextField})
